/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFAutocomplete, RHFCheckbox, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { Hidden, InputAdornment, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

export default function EmpEduNewEditForm({
  streamData,
  qualTypeData,
  qualData,
  universityData,
  currentEmpEdu,
}) {
  // const [genderArr, setGenderArr] = useState([]);
  const { control, setValue, watch, resetField, trigger, clearErrors } = useFormContext();
  const [uni, setUni] = useState('');

  const watchedEmpEdu = watch('empEdu');

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'empEdu',
  });


  useEffect(() => {
    if (fields.length === 0) {
      append({
        eduSrno: 0,
        university: null,
        othrUni: '',
        qualtype: null,
        qualification: null,
        stream: null,
        candpercnt: 0.0,
        candcgpa: 0.0,
        currentypurs: '',
        edufromDate: null,
        edutoDate: null,
      });
    }
  }, [append, fields.length]);


  const handleAdd = () => {
    append({
      eduSrno: 0,
      university: null,
      othrUni: '',
      qualtype: null,
      qualification: null,
      stream: null,
      candpercnt: 0.0,
      candcgpa: 0.0,
      currentypurs: '',
      edufromDate: null,
      edutoDate: null,
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };
  return (
    <>
      <Box
        mt={4}
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
        }}
        mb={3}
      >
        <Box>
          <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
            Education Details:
          </Typography>
        </Box>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add Education
          </Button>
        </Stack>
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={2}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5} sx={{
            p: 1,
            borderRadius: 1,
            bgcolor: item.fromCandidate ? 'grey.100' : 'transparent',
            border: item.fromCandidate ? '0.5px dashed grey' : 'none',
          }} >
            <Typography variant="subtitle2" sx={{ color: 'primary', mb: 1 }}>
              Education {index + 1}:
            </Typography>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <RHFTextField name={`empEdu[${index}].eduSrno`} />
            </Box>
            <Box
              rowGap={1.5}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empEdu[${index}].university`}
                  placeholder="Select University"
                  label={
                    <div>
                      School/University
                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  onChange={(event, value) => {
                    setValue(`empEdu[${index}].university`, value, { shouldValidate: true });
                    if (value != null) {
                      setUni(value.universityName);
                    }
                  }}
                  options={universityData}
                  showPlusIcon
                  prerequisiteMasters={['Country']}
                  getOptionLabel={(option) => option.universityName}
                  renderOption={(props, option) => (
                    <li {...props} key={option.universityId}>
                      {option.universityName}
                    </li>
                  )}
                />
              </Stack>
              {uni === 'Other' && (
                <Stack spacing={1}>
                  <RHFTextField
                    name={`candEdu[${index}].othrUni`}
                    label={<div>University Name</div>}
                  />
                </Stack>
              )}
              <Stack spacing={1}>
                <RHFAutocomplete
                  name={`empEdu[${index}].qualtype`}
                  placeholder="Select qualification Type"
                  label={
                    <div>
                      Qualification Type
                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={qualTypeData}
                  showPlusIcon
                  getOptionLabel={(option) => option.masterName}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
              <Stack spacing={1}>
                <RHFAutocomplete
                  name={`empEdu[${index}].qualification`}
                  placeholder="Select Qualification"
                  label={
                    <div>
                      Qualification<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={qualData}
                  showPlusIcon
                  getOptionLabel={(option) => option.masterName}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
              <Stack spacing={1}>
                <RHFAutocomplete
                  name={`empEdu[${index}].stream`}
                  placeholder="Select Stream"
                  label={
                    <div>
                      Qualification Stream
                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={streamData}
                  showPlusIcon
                  getOptionLabel={(option) => option.masterName}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
              <RHFTextField
                type="number"
                name={`empEdu[${index}].candpercnt`}
                label="Percentage"
                placeholder="0.00"
                onWheel={(e) => e.target.blur()}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <Box sx={{ typography: 'subtitle2', color: 'text.disabled' }}>%</Box>
                    </InputAdornment>
                  ),
                  inputProps: {
                    min: 0, // Set the minimum value allowed
                    max: 100, // Set the maximum value allowed
                  },
                }}
                sx={{ mb: 1.5 }}
              />
              <RHFTextField
                type="number"
                name={`empEdu[${index}].candcgpa`}
                label="CGPA"
                placeholder="0.00"
                onWheel={(e) => e.target.blur()}
                inputProps={{ max: 10 }}
                sx={{ mb: 1.5 }}
              />
            </Box>
             <RHFCheckbox
              name={`empEdu[${index}].currentypurs`}
              label="Currently pursuing"
              labelPlacement="start"
              onChange={(e) => {
                const isChecked = e.target.checked;

                // Update the field value
                setValue(`empEdu[${index}].currentypurs`, isChecked);

                if (isChecked) {
                  // Clear the To Date field immediately
                  setValue(`empEdu[${index}].edutoDate`, null, {
                    shouldValidate: true,
                    shouldDirty: true,
                    shouldTouch: true,
                  });
                }
                trigger(`empEdu[${index}].edutoDate`);
              }}
              sx={{
                '&.MuiFormControlLabel-labelPlacementStart': {
                  margin: 0,
                },
              }}
            />
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <Controller
                name={`empEdu[${index}].edufromDate`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <DatePicker
                    label={
                      <div>
                        From Date<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                      </div>
                    }
                    value={field.value}
                    onChange={(newValue) => {
                      field.onChange(newValue);
                      trigger(`empEdu[${index}].edutoDate`); // trigger the other field
                      trigger(`empEdu[${index}].edufromDate`)
                    }}

                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!error,
                        helperText: error?.message,
                      },
                    }}
                    maxDate={new Date()}
                  />
                )}
              />
              <Controller
                name={`empEdu[${index}].edutoDate`}
                control={control}
                rules={{
                  required: !watch(`empEdu[${index}].currentypurs`) && 'To Date is required',
                  validate: (toDate) => {
                    const fromDate = watch(`empEdu[${index}].edufromDate`);
                    const isCurrentlyPursuing = watch(`empEdu[${index}].currentypurs`);

                    if (isCurrentlyPursuing) return true;

                    if (!fromDate || !toDate) return true;

                    const from = new Date(fromDate);
                    const to = new Date(toDate);

                    if (from > to) {
                      return 'To Date must be after From Date';
                    }
                    return true;
                  },
                }}

                shouldUnregister={watch(`empEdu[${index}].currentypurs`)}
                render={({ field, fieldState: { error } }) => (
                  <DatePicker
                    label={
                      <div>
                        To Date
                        {!watchedEmpEdu?.[index]?.currentypurs && (
                          <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                        )}
                      </div>
                    }
                    value={
                      watch(`empEdu[${index}].currentypurs`)
                        ? null
                        : field.value instanceof Date && !Number.isNaN(field.value.getTime())
                          ? field.value
                          : null
                    }
                    onChange={(newValue) => {
                      const isCurrentlyPursuing = watch(`empEdu[${index}].currentypurs`);

                      const isValid = newValue instanceof Date && !Number.isNaN(newValue.getTime());

                      if (!isCurrentlyPursuing) {
                        field.onChange(isValid ? newValue : null);
                      } else {
                        field.onChange(null);
                      }

                      // Trigger validation updates
                      trigger(`empEdu[${index}].edufromDate`);
                      trigger(`empEdu[${index}].edutoDate`);
                    }}

                    slotProps={{
                      textField: {
                        fullWidth: true,
                        // Force-hide the error whenever "currently pursuing" is
                        // checked, at render time — the resolver's error object
                        // can lag a tick behind the checkbox state, so we don't
                        // rely on it alone.
                        error: watchedEmpEdu?.[index]?.currentypurs ? false : !!error,
                        helperText: watchedEmpEdu?.[index]?.currentypurs ? '' : error?.message,
                      },
                    }}
                    disabled={watch(`empEdu[${index}].currentypurs`)}
                  />
                )}
              />

            </Box>
            {fields.length > 1 && (
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                alignItems={{ xs: 'flex-end', md: 'center' }}
                justifyContent="flex-end"
              >
                <Button
                  size="small"
                  color="error"
                  startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                  onClick={() => handleRemove(index)}
                >
                  Remove
                </Button>
              </Stack>
            )}
          </Stack>
        ))}
      </Stack>
    </>
  );
}
EmpEduNewEditForm.propTypes = {
  universityData: PropTypes.array,
  qualData: PropTypes.array,
  qualTypeData: PropTypes.array,
  streamData: PropTypes.array,
  currentEmpEdu: PropTypes.array,
};
